import React, { useState } from 'react';
import TCITestForm from './TCITestForm';  // Asegúrate de que la ruta sea correcta
import './SurveyComponent.css';

const SurveyComponent = ({user, email, refetch, refetchUser}) => {
    const username = user.replace(/[^a-zA-Z0-9]/g, '');

  const [currentStep, setCurrentStep] = useState(0); 
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [dob, setDob] = useState('');

  const steps = ['Nombre', 'Apellido', 'Fecha de Nacimiento', 'Test TCI'];

  const isNextEnabled = () => {
    switch (currentStep) {
      case 0: return name.trim() !== '';
      case 1: return surname.trim() !== '';
      case 2: return dob.trim() !== '';
      default: return true;
    }
  };

  const handleNext = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handlePrev = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div >
      {/* Indicadores de paso */}
      <div className="survey-steps">
        {steps.map((_, idx) => (
          <span
            key={idx}
            className={`step-dot ${idx <= currentStep ? 'completed' : ''}`}
          />
        ))}
      </div>

      {/* Contenido del paso actual */}
      <div className="survey-content">
        {currentStep === 0 && (
          <div className="input-step">
            <label>Nombre:</label>
            <input
              type="text"
              placeholder="Ingrese su nombre"
              value={name}
              onChange={e => setName(e.target.value)}
            />
          </div>
        )}
        {currentStep === 1 && (
          <div className="input-step">
            <label>Apellido:</label>
            <input
              type="text"
              placeholder="Ingrese su apellido"
              value={surname}
              onChange={e => setSurname(e.target.value)}
            />
          </div>
        )}
        {currentStep === 2 && (
          <div className="input-step">
            <label>Fecha de Nacimiento:</label>
            <input
              type="date"
              value={dob}
              onChange={e => setDob(e.target.value)}
            />
          </div>
        )}
        {currentStep === 3 && (
          <div >
            <TCITestForm username={username} email={email} nombre={name} apellido={surname} fecha={dob} refetch={refetch} refetchUser={refetchUser}/>
          </div>
        )}
      </div>

      {/* Navegación */}
      <div className="survey-navigation">
        {currentStep > 0 && (
          <button onClick={handlePrev} className="navi-button">
            Anterior
          </button>
        )}
        {currentStep < steps.length - 1 ? (
          <button
            onClick={handleNext}
            className="navi-button"
            disabled={!isNextEnabled()}
          >
            Siguiente
          </button>
        ) : null}
      </div>
    </div>
  );
};

export default SurveyComponent;
